import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SettingsType = {
  currency: string;
  countryCode: string;
  language: string;
  timezone: string;
  isNative: boolean; //THE APP ENVIRONMENT iSNATIVE == TRUE MEANS IT IS RUNNING AS A NATIVE APP
};

const initialState: SettingsType = {
  currency: 'NGN',
  countryCode: 'NG',
  language: 'en-NG',
  timezone: 'Africa/Lagos',
  isNative: false,
};

// Individual state mutation reducers

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setUserCountry: (state, action: PayloadAction<SettingsType>) => {
      state = action.payload;
    },
    setCurrency: (state: SettingsType, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },

    setCountryCode: (state: SettingsType, action: PayloadAction<string>) => {
      state.countryCode = action.payload;
    },

    setLanguage: (state: SettingsType, action: PayloadAction<string>) => {
      state.language = action.payload;
    },

    setTimezone: (state: SettingsType, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
    setIsNative: (state: SettingsType, action: PayloadAction<boolean>) => {
      state.isNative = action.payload;
    },
    resetUserCountry: () => initialState,
  },
});

export const {
  resetUserCountry,
  setCountryCode,
  setCurrency,
  setLanguage,
  setTimezone,
  setUserCountry,
  setIsNative,
} = settingsSlice.actions;
export default settingsSlice.reducer;
